type Env = "dev" | "staging" | "prod" | "custom";
export const currentEnv: Env = "prod";
